import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageBanner from "@/components/PageBanner";
import { Link } from "react-router-dom";
import { Tag, Gift, Sparkles, PlayCircle, ArrowRight, ShoppingBag } from "lucide-react";

/**
 * Offers — dedicated page.
 * Contains only current offers/promotions. No plan / products catalog / about
 * content.
 */

const OFFERS = [
  {
    tag: "Just Launched",
    icon: Sparkles,
    title: "Health Starter Kit",
    subtitle: "Kickstart your direct-selling journey.",
    body: "Free associate registration + starter Sales Points activation kit — unlock your Samara ID today.",
    cta: "Register free",
    to: "/register",
  },
  {
    tag: "Hot",
    icon: Gift,
    title: "Beauty Ritual Combo",
    subtitle: "Skincare + hair essentials.",
    body: "Anti-Wrinkle Cream + Neem Aloe Facewash + Aloe Jojoba Shampoo — the complete Samara beauty ritual, crafted with Ayurveda.",
    cta: "Shop Personal Care",
    to: "/products?category=personal_care",
  },
  {
    tag: "Save",
    icon: PlayCircle,
    title: "IT Education Bundle",
    subtitle: "Digital-skills learning bundle. Certified.",
    body: "AI, DCA + DTP + Tally, Office Package and Accounting — pick any bundle for career-ready outcomes.",
    cta: "Explore Courses",
    to: "/courses",
  },
  {
    tag: "Family",
    icon: ShoppingBag,
    title: "Family Special Combo",
    subtitle: "Health + Personal Care + Education.",
    body: "Everything to get your family on the wellness path — one combo, three categories.",
    cta: "See Combos",
    to: "/products?category=combo",
  },
];

export default function OffersPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <PageBanner
        label="Current Offers"
        title="The season's best Samara picks."
        subtitle="Festive combos, category launches and limited-time associate promotions — the freshest deals across Health, Personal Care, Education and Combos."
        crumbs={[{ label: "Home", to: "/" }, { label: "Offers" }]}
        tone="gold"
      />

      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {OFFERS.map((o) => (
            <div
              key={o.title}
              data-testid={`offer-${o.title.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className="p-6 border border-line rounded-sm bg-white hover:border-gold/50 hover:shadow-lg transition-all"
            >
              <div className="flex items-start justify-between">
                <div className="w-11 h-11 grid place-items-center bg-gold/10 border border-gold/30 rounded-sm">
                  <o.icon size={20} className="text-gold-deep" />
                </div>
                <span className="text-[10px] uppercase tracking-widest bg-royal text-white px-2 py-0.5 rounded-sm">
                  {o.tag}
                </span>
              </div>
              <div className="font-serif text-2xl text-royal mt-4">{o.title}</div>
              <div className="text-xs uppercase tracking-widest text-gold-deep mt-1">
                {o.subtitle}
              </div>
              <p className="text-sm text-navy/65 mt-3 leading-relaxed">{o.body}</p>
              <Link
                to={o.to}
                className="mt-5 inline-flex items-center gap-1 text-sm text-royal hover:text-gold border-b border-royal hover:border-gold pb-0.5"
              >
                {o.cta} <ArrowRight size={14} />
              </Link>
            </div>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
